/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Spanish (International)
export default {
  'team-central.give-jira-kudos.created.description.flag': 'Nuestro equipo de experiencia del espacio de trabajo procesará ahora la solicitud de regalo. ✨',
  'team-central.give-jira-kudos.created.title.flag': 'Felicitación creada',
  'team-central.give-jira-kudos.creation.failed.description.flag': 'No se han podido crear tus felicitaciones ni enviar el regalo. Intenta generar un ticket independiente en <a>go/kudos</a>.',
  'team-central.give-jira-kudos.creation.failed.title.flag': 'Se ha producido un error',
  'team-central.give-kudos.button': 'Felicitar',
  'team-central.give-kudos.close-button.label': 'Cerrar cajón',
  'team-central.give-kudos.confirm-close.title': 'Confirmar cerrar',
  'team-central.give-kudos.created.description.flag': 'Se ha enviado tu felicitación. <a>Ver felicitación</a>',
  'team-central.give-kudos.created.title.flag': 'Felicitación creada',
  'team-central.give-kudos.creation.failed.description.flag': 'No se ha podido crear tu felicitación.',
  'team-central.give-kudos.creation.failed.title.flag': 'Se ha producido un error',
  'team-central.give-kudos.error-icon.label': 'Error',
  'team-central.give-kudos.success-icon.label': 'Listo',
  'team-central.give-kudos.unsaved.warning': 'Tus cambios no se guardarán.',
  'team-central.give-kudos.unsaved.warning.cancel': 'Cancelar',
  'team-central.give-kudos.unsaved.warning.close': 'Cerrar'
};